const Contact = () => (
  <div className="contact mt-20">
    <p>Please contact us for evaluation license or other requests.</p>
    <div className="contact__action">
        <a href="mailto: sales@matlogica.com" className="price-btn primary-btn mt-10">
            E-mail us
            <span className="lnr lnr-arrow-right"></span>
        </a>
        <span className="contact__separator"> or better</span>
        <a href="javascript:void(0);" className="primary-btn primary-btn_no-icon" onClick={() => { Calendly.initPopupWidget({url: 'https://calendly.com/matlogica'}); return false;}}>
            Request a demo
        </a>
    </div>
  </div>
);

export default Contact;
